<section class="content">
    <!-- Default box -->
    <ul class="nav nav-tabs">
        <li class="nav-item">
            <a
                class="nav-link"
                routerLinkActive="tab-link-active"
                [routerLink]="uri.getRouteNavPath('adminSettingsFees')">
                Default Fees & Earnings
            </a>
        </li>
    </ul>
</section>
